import { TextField, MenuItem, Tooltip } from '@mui/material'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  groupBy: string[]
  value: string
  onChange: (next: string) => void
}

export function ColumnsSelect({ groupBy, value, onChange }: Props) {
  const disabled = groupBy.length === 0
  const select = (
    <TextField
      select
      label={CONTROLS.columns}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      sx={{ minWidth: 200 }}
    >
      <MenuItem value="">
        <em>{CONTROLS.columnsNone}</em>
      </MenuItem>
      {groupBy.map((dim) => (
        <MenuItem key={dim} value={dim}>
          {dim}
        </MenuItem>
      ))}
    </TextField>
  )
  return disabled ? (
    <Tooltip title={CONTROLS.columnsNeedsGroupBy}>
      <span>{select}</span>
    </Tooltip>
  ) : (
    select
  )
}
